import { CONTENT_HOME_GET, SELECTED_REGION_GET } from './types';

export default {
  [CONTENT_HOME_GET]: (state) => state.content,
  [SELECTED_REGION_GET]: (state) => state.selectedRegionTid,
};
